// extracted by mini-css-extract-plugin
export var img = "Post-module--img--mXpg4";